import React, { useState, useEffect, useRef } from "react";
import LinkButton from "./LinkButton";
//Import Icons
import SearchIcon from "../../images/library-searchIcon.svg";
import clearTextIconBlue from "../../images/Close-Small.svg";
import { ClickAwayListener } from "@material-ui/core";

//Import styles
import "./RoundedSearchTextField.scss";

const SearchTextField = ({
  placeholder = "Search...",
  onTextChange,
  handleSearch,
  expandable,
  setSearchExpand
  
}) => {
    const [inputValue,setInputValue]=useState("");
  const searchButtonRef = useRef("");
   const [isSearchBarEmpty, setIsSearchBarEmpty] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  
  const handleFocus = () => {
    setIsFocused(true);
    setSearchExpand(true)
  };

  const handleBlur = (e) => {
      setInputValue("");
      //onTextChange("");
      setIsSearchBarEmpty(true);
    setIsFocused(false);
    setSearchExpand(false)
  };
  const clearTextField = () => {
    const element = document.getElementById("tf-search-field");
    if (element) {
      element.value = "";
      setInputValue("");
      setIsSearchBarEmpty(true);
      setSearchExpand(true)
     // onTextChange(element.value);
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onTextChange(inputValue)
      setSearchExpand(true)
     // handleSearch(event);
    }
  };
  const handleSearchClick = (event) => {
    handleSearch(event);
  };
  return (
    <ClickAwayListener onClickAway={handleBlur}>
      <div
        className={`tf-rounded-search ${expandable ? "expandable" : ""} ${
          isFocused ? "focused" : ""
          }`}
        style={isFocused ? {flexGrow: 1, transition:'all 0.8s ease-in'}:{width:'16%', transition:'all 0.8s ease'}}
      >
        <div className="d-flex align-items-center">
          <img src={SearchIcon} alt="" className="search-icon"  style={{marginBottom:isFocused?'2px':''}}/>
          <input
            id="tf-search-field"
            type="text"
            value={inputValue || ""}
            placeholder={placeholder}
            onFocus={handleFocus}
            className="search-input"
            autoComplete="off"
            onKeyPress={handleKeyPress}
            //   onFocus={handleFocus}

            onDrop={(e) => e.preventDefault()} // Prevents default behavior of dropping files
            onChange={(e) => {
              if (e.target.value?.trim().length > 0) {
                setInputValue(e.target.value)
                setIsSearchBarEmpty(false);
              } else {
                setIsSearchBarEmpty(true);
                setInputValue("")
              }
             // onTextChange(e.target.value);
            }}
          />

          {isFocused && (
            <LinkButton
              ref={searchButtonRef}
              className=""
              handleClick={(event) => {
                // handleSearchClick(event);
                onTextChange(inputValue)
              }}
              disabled={isSearchBarEmpty}
              title="SEARCH"
              height="32px"
            />
          )}

          {isFocused &&
              <img
                src={clearTextIconBlue}
                alt="Clear text"
                className=""
                style={{ cursor: "pointer" }}
                onClick={() => {
                    if (inputValue.length > 0) {
                     clearTextField();
                    }
                    else{
                        handleBlur();
                    }
                  
                }}
              />
            }
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default SearchTextField;
